//blueprint to display national data
//created by Katherine O'Donnell
import "./index.css";
import "./national.css";

import NationalTimeSeries from "../EPHCharts/national";
import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import NationalTable from "../EPHTable/national";
import FadeInSection from "../FadeInSection";
import Accordion from "../Accordion/Accordion";
const React = require("react");


//calling NationalData on the eph page will generate a data layout for any measure selected
//NationalData returns a .jsx layout with a header, time series graph, filters, and custom description for each national measure
const NationalData = ({measure, units, measureID}) => {
//this section of code handles filter changes
    const [selectedPercentile, setSelectedPercentile] = React.useState(
        parseInt(sessionStorage.getItem("currentTab")) || 1
    );
    const [selectedDemographic, setSelectedDemographic] = React.useState(
        16 // Set an initial value for demographic filter
      );
      
    function chooseFilters(percentile, demographic) {
        sessionStorage.setItem("selectedPercentile", percentile);
        setSelectedDemographic(demographic);
        setSelectedPercentile(percentile);
    }

    useEffect(() => {
        chooseFilters(1, 16); //default 50th percentile, us population
      }, []); // empty dependency array so effect runs only once
//end of filter code

//create date object to be used in data citation - shows that the app pulls from the EPH API the day the user is accessing the site
    const currentDate = new Date();
    const formattedDate = `${currentDate.getMonth() + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`;

    function getSubtitle(subtitle) { 
      if(measureID === 858) {
          return subtitle = "National Report on Human Exposure to Environmental Chemicals | Lead in Blood"; 
        }
        else if (measureID === 856) {
          return subtitle = "National Report on Human Exposure to Environmental Chemicals | Metals and Metalloids in Urine 1999-2014 (Creatinine Corrected)"    
        }
        
        else if (measureID === 863) {
          return subtitle = "National Report on Human Exposure to Environmental Chemicals | Phthalate Metabolites in Urine (Creatinine Corrected)"  
        }
    
        else if (measureID === 859) {
          return subtitle = "National Report on Human Exposure to Environmental Chemicals | Personal Care and Consumer Products Metabolites in Urine (Creatinine Corrected)" 
        }
        else if (measureID === 826) {
          return subtitle = "National Report on Human Exposure to Environmental Chemicals | Perfluoroalkyl and Polyfluoroalkyl Substances: Surfactants in Blood" 
        }
        else if (measureID === 861) {
          return subtitle = "National Report on Human Exposure to Environmental Chemicals | Pesticide Metabolites: Herbicide Metabolites in Urine (Creatinine Corrected)"
        }
        
  }

    const accordionMeasure = [
        {
          measureID: 858,
          sections: [
            {
              title: 'Where did we get this data?',
              content: `Accessed From: https://ephtracking.cdc.gov/DataExplorer. Accessed on ${formattedDate}`,
            },
            {
              title: 'Where did CDC get this data?',
              content: "Data provided by Centers for Disease Control and Prevention, National Center for Health Statistics (NCHS), National Health and Nutrition Examination Survey (NHANES) (http://www.cdc.gov/nchs/nhanes.htm) as presented in the National Report on Human Exposure to Environmental Chemicals, Updated Tables  (http://www.cdc.gov/exposurereport/)",
            },
          ],
        },
        {
          measureID: 856,
          sections: [
            {
              title: 'Where did we get this data?',
              content: `Accessed From: https://ephtracking.cdc.gov/DataExplorer. Accessed on ${formattedDate}`,
            },
            {
              title: "Where did CDC get this data?",
              content: "Data provided by Centers for Disease Control and Prevention, National Center for Health Statistics (NCHS), National Health and Nutrition Examination Survey (NHANES) (http://www.cdc.gov/nchs/nhanes.htm) as presented in the National Report on Human Exposure to Environmental Chemicals, Updated Tables  (http://www.cdc.gov/exposurereport/)",
            },
          ],
        },
        {
          measureID: 863,
          sections: [
            {
              title: "Where did we get this data from?",
              content: `Accessed From: https://ephtracking.cdc.gov/DataExplorer. Accessed on ${formattedDate}`,
            },
            {
              title: "Where did the CDC get this data from?",
              content: "Data provided by Centers for Disease Control and Prevention, National Center for Health Statistics (NCHS), National Health and Nutrition Examination Survey (NHANES) (http://www.cdc.gov/nchs/nhanes.htm) as presented in the National Report on Human Exposure to Environmental Chemicals, Updated Tables  (http://www.cdc.gov/exposurereport/)",
            },
          ],
        },
        {
          measureID: 859,
          sections: [
            {
              title: "Where did we get this data from?",
              content: `Accessed From: https://ephtracking.cdc.gov/DataExplorer. Accessed on ${formattedDate}`,
            },
            {
              title: "Where did the CDC get this data from?",
              content: "Data provided by Centers for Disease Control and Prevention, National Center for Health Statistics (NCHS), National Health and Nutrition Examination Survey (NHANES) (http://www.cdc.gov/nchs/nhanes.htm) as presented in the National Report on Human Exposure to Environmental Chemicals, Updated Tables  (http://www.cdc.gov/exposurereport/)",
            },
          ],
        },
        {
          measureID: 826,
          sections: [
            {
              title: "Where did we get this data from?",
              content: `Accessed From: https://ephtracking.cdc.gov/DataExplorer. Accessed on ${formattedDate}`,
            },
            {
              title: "Where did the CDC get this data from?",
              content: "Data provided by Centers for Disease Control and Prevention, National Center for Health Statistics (NCHS), National Health and Nutrition Examination Survey (NHANES) (http://www.cdc.gov/nchs/nhanes.htm) as presented in the National Report on Human Exposure to Environmental Chemicals, Updated Tables  (http://www.cdc.gov/exposurereport/)",
            },
          ],
        },
        {
          measureID: 861,
          sections: [
            {
              title: "Where did we get this data from?",
              content: `Accessed From: https://ephtracking.cdc.gov/DataExplorer. Accessed on ${formattedDate}`,
            },
            {
              title: "Where did the CDC get this data from?",
              content: "Data provided by Centers for Disease Control and Prevention, National Center for Health Statistics (NCHS), National Health and Nutrition Examination Survey (NHANES) (http://www.cdc.gov/nchs/nhanes.htm) as presented in the National Report on Human Exposure to Environmental Chemicals, Updated Tables  (http://www.cdc.gov/exposurereport/)",
            },
          ],
        },
      ];
    
      const currentAccordionMeasure = accordionMeasure.find(
        section => section.measureID === measureID
      );

    //.jsx layout
    return(
        <div className="national-container">
            <FadeInSection>
            <FadeInSection>
            <h1>{measure +" (National Data)"}</h1>
            <h3>{getSubtitle()}</h3>
            </FadeInSection>
            <div className="filter-container">
                <FadeInSection>
                <div className="percentile-filter">
                    <p>Select a percentile estimate:</p>
                    <select value={selectedPercentile} onChange={(e) => chooseFilters(parseInt(e.target.value), selectedDemographic)}>
                        {/*in API endpoints, percentileID=1 for 50th, 2 for 95th. 'value' passed as percentile id */}
                        <option value={1}>50th percentile</option>
                        <option value={2}>95th percentile</option>
                    </select>
                </div>
                </FadeInSection>
                <FadeInSection>
                <div className="demographic-filter">
                    <p>Select a demographic group:</p>
                    <select value={selectedDemographic} onChange={(e) => chooseFilters(selectedPercentile, parseInt(e.target.value))}>
                        {/*value number passed as demographic id */}
                        <option value={16}>U.S. Population</option> {/*api endpoint demographic ID = 16 for U.S. pop*/}
                        <option value={9}>Females</option> {/*api endpoint demographic ID = 9 for female data*/}
                        <option value={10}>Males</option> {/*api endpoint demographic ID = 10 for male data*/}
                        <option value={1}>1-5 Years</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={4}>6-11 Years</option> {/*api endpoint demographic ID = 1 for 6-11 y/o*/}
                        <option value={5}>12-19 Years</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={7}>20+ Years</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={11}>All Hispanics</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={12}>Mexican Americans</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={13}>Non-Hispanic Asians</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={14}>Non-Hispanic Blacks</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                        <option value={15}>Non-Hispanic Whites</option> {/*api endpoint demographic ID = 1 for 1-5 y/o*/}
                    </select>
                </div>
                </FadeInSection>
            </div>
            {/*code below changes data representation based on filter changes*/}
            
            
            <div className="time-series">
                <FadeInSection>
                    {selectedPercentile === 1 && (
                    <NationalTimeSeries
                        size={{ width: 800, height: 400 }}
                        measure={measure}
                        units={units}
                        percentile={1}
                        demographic={selectedDemographic}
                    />
                    )}
                </FadeInSection>

                <FadeInSection>
                    {selectedPercentile === 2 && (
                    <NationalTimeSeries
                        size={{ width: 800, height: 400 }}
                        measure={measure}
                        units={units}
                        percentile={2}
                        demographic={selectedDemographic}
                    />
                    )}
                </FadeInSection>
            </div>
            <div className = "desc-container">
            </div>
             
            <div className="eph-table-container">
            <FadeInSection>
                <h2>Table for {measure}</h2>
                <NationalTable measure={measure} />
            </FadeInSection>
            </div>
            {currentAccordionMeasure &&
          currentAccordionMeasure.sections.map(section => (
            <FadeInSection key={section.title}>
              <Accordion title={section.title} content={section.content} />
            </FadeInSection>
          ))}

            
            </FadeInSection>
        </div>
    );
}

NationalData.propTypes = {
    measure: PropTypes.string.isRequired,       //measure selected on eph page
    units: PropTypes.string.isRequired,         //y axis units of measure selected on eph page
    measureID: PropTypes.number.isRequired      //measureID to pass to api endpoint for
};

var samples = "Biomonitoring is conducted via individual and pooled blood or urine samples tested by CDC scientists. Samples have been collected from individuals across teh United States that took part in the CDC's National Health and Nutrition Examination Survey (NHANES). The NHANES study is designed so that the sample measures of chemicals in participants can be representatives of exposures in the entire U.S. civilian population, and the data can be filtered to represent smaller demographic groups.";

//diff info passed to the 'about data' section for each measure 
var details = {
    "Lead in Blood": {
        desc: "lead in blood, in micrograms of lead per liter of blood. ",
        lod: "The LOD (µg/dL) for Lead for the Survey years 1999-2000, 2001-2002, 2003-2004, 2005-2006, 2007-2008, 2009-2010, 2011-2012, 2013-2014 and 2015-2016 are the following: 0.3, 0.3, 0.28, 0.25, 0.25, 0.25, 0.25, 0.07 and 0.07, respectively."
    },
    "Metals in Urine":  {
        desc: "arsenic in urine, in micrograms of arsenic per gram of urine. ",
        lod: ""
    },
    "Phthalate Metabolites in Urine (creatinine corrected)": {
        desc: "phthalate metabolites in urine, in micrograms of MBzP per gram of urine. ",
        lod: ""
    },
    "Bisphenol and Paraben in Urine": {
        desc: "bisphenol and paraben in urine, in micrograms of BPA per gram of urine. ",
        lod: ""
    },
    "PFAS in Blood": {
        desc: "PFAS in blood,  in micrograms of PFOS per liter of blood. ",
        lod: ""
    },
    "Pesticides in Urine": {
        desc: "pesticides in urine, in micrograms of OPM per gram of urine. ",
        lod: ""
    }
}



export default NationalData;